import React from 'react';
import { Name } from '../../facades/Icon';
import { Icon } from '../../facades';

const element = <Icon className="buttonIcon" lib="fal" icon={'hourglass-half'} />;

export interface AsureCloudButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  state: 'primary' | 'secondary' | 'danger' | 'success' | 'link' | 'dark-primary' | 'dark-secondary';
  iconPosition?: 'left' | 'right';
  icon?: Name;
  text: string;
  loading?: boolean;
  className?: string;
}
export const AsureCloudButton = ({ state,icon, iconPosition, text, loading, className, ...props }: AsureCloudButton) => {
  
  let classList = '';
  classList += ` btn-${state}`;
  classList += iconPosition === 'left' ? ' flex-row' : ' flex-row-reverse';
  classList += !props.disabled ? '' : ' disabled';
  classList += loading || icon ? ' icon-added' : '';
  return (
    <button className={`cloud btn d-flex justify-content-between align-items-center ${className} ${classList}`} {...props}>
      {loading && element}
      {!loading && icon && <Icon className="buttonIcon"  icon={icon} lib="fal"  />}
      {text}
    </button>
  );
};
export default AsureCloudButton;
